<div class="auth-single-page">
  <div class="auth-card">
    <div class="form-header-logos">
      <img src="assets/images/ds-small.png" alt="Datascoring" class="header-logo-ds" />
      <span class="header-version">v{{ version }}</span>
    </div>

    <div class="auth-card-content">
      <div class="login-header">
        <img [src]="'assets/images/' + logo" alt="Logo" class="login-logo-cafam" />
        <p class="login-subtitle">Por seguridad, actualiza tu contraseña para continuar.</p>
      </div>

      <div class="auth-form-block" appPermissionControl="P005F0001">
        <p class="auth-form-title">Cambiar contraseña</p>
        <p class="auth-form-desc">Ingresa tu contraseña actual y define la nueva contraseña.</p>
        <form [formGroup]="formData" class="login-form">
          <div class="form-field">
            <span class="p-input-icon-left">
              <i class="pi pi-lock"></i>
              <p-password
                formControlName="passwordLast"
                placeholder="Contraseña anterior"
                [feedback]="false"
                [toggleMask]="true"
                [class.p-invalid]="formData.get('passwordLast')?.invalid && formData.get('passwordLast')?.touched"
                appPermissionControl="P005K0001"
              ></p-password>
            </span>
            <small class="p-error" *ngIf="formData.get('passwordLast')?.invalid && formData.get('passwordLast')?.touched">
              Ingresa tu contraseña actual
            </small>
          </div>
          <div class="form-field">
            <span class="p-input-icon-left">
              <i class="pi pi-key"></i>
              <p-password
                formControlName="passwordNew"
                placeholder="Nueva contraseña"
                [feedback]="true"
                [toggleMask]="true"
                [class.p-invalid]="formData.get('passwordNew')?.invalid && formData.get('passwordNew')?.touched"
                appPermissionControl="P005K0002"
              ></p-password>
            </span>
            <small class="p-error" *ngIf="formData.get('passwordNew')?.invalid && formData.get('passwordNew')?.touched">
              Mínimo 6 caracteres
            </small>
          </div>
          <div class="form-field">
            <span class="p-input-icon-left">
              <i class="pi pi-key"></i>
              <p-password
                formControlName="passwordNewConfirm"
                placeholder="Confirmar nueva contraseña"
                [feedback]="false"
                [toggleMask]="true"
                [class.p-invalid]="formData.get('passwordNewConfirm')?.invalid && formData.get('passwordNewConfirm')?.touched"
                appPermissionControl="P005K0003"
              ></p-password>
            </span>
            <small class="p-error" *ngIf="formData.get('passwordNewConfirm')?.invalid && formData.get('passwordNewConfirm')?.touched">
              Las contraseñas deben coincidir
            </small>
          </div>
        </form>
        <div class="login-actions">
          <button
            pButton
            type="button"
            label="Actualizar contraseña"
            icon="pi pi-check"
            iconPos="right"
            [loading]="loading"
            [disabled]="!formData.valid || loading"
            class="btn-primary w-100"
            (click)="validateFields()"
            appPermissionControl="P005K0004"
          ></button>
        </div>
      </div>

      <div class="login-actions back-link">
        <a [routerLink]="['/sign-in']" class="link-back">
          <i class="pi pi-arrow-left"></i> Volver al inicio de sesión
        </a>
      </div>
    </div>

    <footer class="auth-card-footer">
      <p class="footer-text">© {{ currentYear }} Digisolutions. Todos los derechos reservados.</p>
    </footer>
  </div>
</div>

<p-toast position="bottom-right"></p-toast>
